<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="类型" label-width="80px">
        <el-radio-group v-model="queryParam.type" @change="handleTypeChange" style="height: 33px;">
          <el-radio>全部</el-radio>
          <el-radio :label="0">门店</el-radio>
          <el-radio :label="1">服务商</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="(queryParam.type === 0 ? '门店' : queryParam.type === 1 ? '服务商' : '') + '名称'" label-width="98px">
        <el-select v-model="queryParam.userSn" clearable filterable :disabled="!queryParam.type && queryParam.type !== 0"
                   remote :remote-method="getUsers" :loading="loading" placeholder="输入名称搜索">
          <el-option v-for="item in users" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" label-width="80px">
        <el-radio v-model="queryParam.status">全部</el-radio>
        <el-radio v-model="queryParam.status" :label="0">执行中</el-radio>
        <el-radio v-model="queryParam.status" :label="1">续约</el-radio>
        <el-radio v-model="queryParam.status" :label="2">过期</el-radio>
      </el-form-item>
      <el-form-item label="时间" label-width="80px">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>合同列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="success" @click="showContract()">
              <el-icon><plus /></el-icon>新增合同
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="contracts" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '门店' : scope.row.type === 1 ? '服务商' : '未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="companyName" label="公司名称"></el-table-column>
      <el-table-column prop="contactName" label="联系人"></el-table-column>
      <el-table-column prop="contactPhone" label="联系电话"></el-table-column>
      <el-table-column label="期限">
        <template #default="scope">
          {{scope.row.startDate}}至{{scope.row.endDate}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{scope.row.status === 0 ? '执行中' : scope.row.status === 1 ? '续约' : scope.row.status === 2 ? '过期' : '未知'}}
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showPics(scope.row)">预览</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showContract(scope.row)">修改</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="contract.sn ? '修改合同' : '新增合同'" v-model="saveVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="contract" ref="contract">
      <el-form-item label="类型" label-width="88px">
        <el-radio-group v-model="contract.type" :disabled="contract.sn" @change="handleTypeChange" style="height: 33px;">
          <el-radio :label="0">门店</el-radio>
          <el-radio :label="1">服务商</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="(contract.type === 0 ? '门店' : contract.type === 1 ? '服务商' : '') + '名称'" label-width="88px">
        <el-select v-if="!contract.sn" v-model="contract.userSn" clearable filterable :disabled="contract.type === null || contract.type === ''"
                   remote :remote-method="getUsers2" :loading="loading2" placeholder="输入名称搜索">
          <el-option v-for="item in users2" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
        </el-select>
        <el-input v-else v-model="contract.companyName" readonly/>
      </el-form-item>
      <el-form-item label="合同期限" label-width="88px">
        <el-date-picker
            v-model="dateRange2"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="图片" label-width="88px">
        <div class="image_list" v-for="(item, index) in contract.picAddress" :key="index">
          <el-icon class="delete_btn" @click="handleRemove(index)"><delete /></el-icon>
          <el-image :src="$utils.imageSrc(item)" :preview-src-list="[$utils.imageSrc(item)]" fit="cover"></el-image>
        </div>
        <el-upload :action="apiBase + 'api/v1/common/upload/image/contract'" :show-file-list="false"
                   :on-success="handleSuccess" :before-upload="beforeUpload">
          <el-button>添加图片</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注" label-width="88px">
        <el-input type="text" v-model="contract.memo"></el-input>
      </el-form-item>
      <el-button type="primary" @click="saveContract">确定</el-button>
    </el-form>
  </el-dialog>

  <el-image-viewer v-if="showViewer" @close="closeViewer" :url-list="viewerUrls" />
</template>

<script>
export default {
  name: "合同管理",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      dateRange: null,
      contracts: [],
      saveVisible: false,
      contract: {},
      dateRange2: null,
      loading: false,
      users: [],
      loading2: false,
      users2: [],
      showViewer: false,
      viewerUrls: []
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file) {
      this.contract.picAddress.push(res.data)
    },
    handleRemove(index) {
      console.log(index)
      this.contract.picAddress.splice(index, 1)
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      if (this.dateRange) {
        this.queryParam.startDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else {
        this.queryParam.startDate = null
        this.queryParam.endDate = null
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.operationContract.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let contracts = response.data.data
        contracts.forEach(item => item.picAddress = item.picAddress.split(','))
        this.contracts = contracts
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list()
    },
    showContract(contract) {
      this.saveVisible = true
      if (!contract) {
        this.contract = {
          type: 0,
          picAddress: []
        }
      } else {
        Object.assign(this.contract, contract)
        this.dateRange2 = [this.contract.startDate, this.contract.endDate]
      }
    },
    saveContract() {
      if (!this.contract.userSn) {
        this.$message.error('请选择门店或服务商')
        return
      }
      if (!this.contract.picAddress || this.contract.picAddress.length <= 0) {
        this.$message.error('请上传图片')
        return
      }
      if (!this.dateRange2) {
        this.$message.error('请选择合同期限')
        return
      } else {
        this.contract.startDate = this.dateRange2[0]
        this.contract.endDate = this.dateRange2[1]
      }
      if (!this.contract.sn) {
        this.$apis.operationContract.add(this.contract).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.operationContract.edit(this.contract).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveVisible = false
            this.list()
          }
        })
      }
    },
    handleTypeChange() {
      this.users = []
      this.users2 = []
      this.queryParam.userSn = null
      this.contract.userSn = null
    },
    showPics(contract) {
      this.viewerUrls = []
      contract.picAddress.forEach(item => this.viewerUrls.push(this.$utils.imageSrc(item)))
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    },
    getUsers(str) {
      if (str !== '') {
        this.loading = true
        let param = {companyName: str}
        if (this.queryParam.type === 0) {
          this.$apis.shopMgr.list(0, 15, param).then(response => {
            this.users = response.data.data
            this.loading = false
          })
        } else if (this.queryParam.type === 1) {
          this.$apis.agentMgr.list(0, 15, param).then(response => {
            this.users = response.data.data
            this.loading = false
          })
        } else {
          this.loading = false
        }
      } else {
        this.users = []
      }
    },
    getUsers2(str) {
      if (str !== '') {
        this.loading2 = true
        let param = {companyName: str}
        if (this.contract.type === 0) {
          this.$apis.shopMgr.list(0, 15, param).then(response => {
            this.users2 = response.data.data
            this.loading2 = false
          })
        } else if (this.contract.type === 1) {
          this.$apis.agentMgr.list(0, 15, param).then(response => {
            this.users2 = response.data.data
            this.loading2 = false
          })
        } else {
          this.loading2 = false
        }
      } else {
        this.users2 = []
      }
    }
  },
  created() {
    this.list()
  }
}
</script>

<style scoped>
.image_list {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 6px 6px 0 0;
}
.image_list .delete_btn {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 100;
  font-size: 18px;
  cursor: pointer;
}
.image_list .delete_btn:hover {
  color: #409EFF;
}
</style>